import { render } from "./ValueListHeader.vue?vue&type=template&id=068ed6de"
import script from "./ValueListHeader.vue?vue&type=script&lang=js"
export * from "./ValueListHeader.vue?vue&type=script&lang=js"

import exportComponent from "/web/markle/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"ValueListHeader.vue"]])

export default __exports__